"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var customDatalayerInterface_1 = require("../../../../../common/utilities/customDatalayerInterface");
var JourneyStepsRoutes_1 = require("../../checkout4/enum/JourneyStepsRoutes");
var dxpDataLayerFeatureService_1 = require("../../../../../common/utilities/dxpDataLayerFeatureService");
exports.formatDataLayerDeal = function (deal) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
    if (!deal) {
        return null;
    }
    var _s = (_a = deal) === null || _a === void 0 ? void 0 : _a.car, model = _s.model, engine = _s.engine, specPack = _s.specPack, exterior = _s.exterior, interior = _s.interior, bodyStyle = _s.bodyStyle, aggregatedOptions = _s.aggregatedOptions, selectedFeatures = _s.selectedFeatures;
    return {
        model: (_c = (_b = model) === null || _b === void 0 ? void 0 : _b.attributes) === null || _c === void 0 ? void 0 : _c.shortname,
        motor: (_e = (_d = engine) === null || _d === void 0 ? void 0 : _d.attributes) === null || _e === void 0 ? void 0 : _e.shortname,
        versions: (_g = (_f = specPack) === null || _f === void 0 ? void 0 : _f.attributes) === null || _g === void 0 ? void 0 : _g.shortname,
        exteriorColor: (_h = exterior) === null || _h === void 0 ? void 0 : _h.shortname,
        interiorColor: (_j = interior) === null || _j === void 0 ? void 0 : _j.shortname,
        accessories: (_k = selectedFeatures) === null || _k === void 0 ? void 0 : _k.map(function (feature) { var _a; return (_a = feature) === null || _a === void 0 ? void 0 : _a.shortname; }).toString(),
        transmission: (_m = (_l = engine) === null || _l === void 0 ? void 0 : _l.attributes) === null || _m === void 0 ? void 0 : _m.transmissionLabel,
        bodyType: (_p = (_o = bodyStyle) === null || _o === void 0 ? void 0 : _o.attributes) === null || _p === void 0 ? void 0 : _p.shortname,
        engineType: (_r = (_q = engine) === null || _q === void 0 ? void 0 : _q.attributes) === null || _r === void 0 ? void 0 : _r.shortname,
        // TODO - update when seatCapacity will be available
        seatCapacity: null,
        options: aggregatedOptions,
        servicePlan: dxpDataLayerFeatureService_1.default.getServicePlan(selectedFeatures),
    };
};
exports.getSaveEnquiryFormNextSteps = function () {
    var _a, _b, _c;
    var dataLayer = window.dataLayer.find(function (e) { return e.eventName && e.eventName === customDatalayerInterface_1.DxpDataLayerEventNames.CONFIGURATOR_ENTRY; });
    var steps = (_a = dataLayer) === null || _a === void 0 ? void 0 : _a.nextSteps;
    var activeStep = (_b = steps) === null || _b === void 0 ? void 0 : _b.indexOf(JourneyStepsRoutes_1.JourneyStepsRoutes.DEALER.replace('/', ''));
    return (_c = steps) === null || _c === void 0 ? void 0 : _c.slice(activeStep + 1);
};
exports.getCheckoutSteps = function (steps, activeStep) {
    var _a;
    return ({
        stepName: (_a = steps[activeStep]) === null || _a === void 0 ? void 0 : _a.pathname.replace('/', ''),
        nextSteps: steps.slice(activeStep + 1).map(function (_a) {
            var pathname = _a.pathname;
            return pathname.replace('/', '');
        }),
    });
};
